import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BoampAvisWrapper } from '../models/BoampAvisWrapper';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../../administration/models/user';
import { Avis } from '../../../models/avis';
import { InputIdEnrichmentService } from './input-id-enrichment.service';
import { FormulaireServiceService } from '../../formulaires/services/formulaire-service.service';

@Injectable({
  providedIn: 'root'
})
export class ImportAvisService {


  constructor(
    private httpClient: HttpClient,
    private inputIdEnrichmentService: InputIdEnrichmentService,
    private formulaireService: FormulaireServiceService
  ) { }

  /**
   * @author KACIMI HAMZA
   */
  public searchBoampAvis(idWeb:string,siret:string,service:string,loginAnnouceur:string):Observable<BoampAvisWrapper>{
	return this.httpClient.get<BoampAvisWrapper>(
		environment.piste_base_url+"/avis/boamp/findByReference/?idWeb="+
		idWeb+"&siret="+siret+"&service="+service+"&loginAnnonceur="+loginAnnouceur
	);
  }
  /**
   * @author KACIMI HAMZA
   */
  public import(idWeb:string,user:User,loginAnnouceur:string):Observable<any>{
  	return this.httpClient.post<any>(
  		environment.piste_base_url+"/avis/boamp/import/?idWeb="+
  		idWeb+"&loginAnnonceur="+loginAnnouceur,user);
  }

  /**
   * Importe un avis BOAMP, enrichit le JSON côté frontend avec les inputIds
   * et lance une sauvegarde (update) dans le backend.
   *
   * Cette méthode enchaîne les appels :
   * 1. Import BOAMP -> récupère l'avis sans inputIds
   * 2. Enrichissement frontend -> ajoute les inputIds au JSON en utilisant le mapping du formulaire
   * 3. Update backend -> sauvegarde l'avis enrichi
   *
   * @param idWeb L'identifiant web de l'avis BOAMP
   * @param user L'utilisateur effectuant l'import
   * @param loginAnnouceur Le login de l'annonceur
   * @returns Observable<Avis> L'avis enrichi et sauvegardé
   */
  public importAndEnrich(idWeb: string, user: User, loginAnnouceur: string, refConsultation?: string): Observable<Avis> {
    return this.import(idWeb, user, loginAnnouceur).pipe(
      switchMap((importedAvis: Avis) => {
        return this.inputIdEnrichmentService.enrichWithInputIds(importedAvis);
      }),
      switchMap((enrichedAvis: Avis) => {
        if (refConsultation && refConsultation.trim() !== '') {
          enrichedAvis.refConsultation = refConsultation;
        }
        return this.formulaireService.update(enrichedAvis);
      })
    );
  }
}

